import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Icon } from '@bos/ui';
import { getSnackbarIconVariant } from './helpers/getSnackbarIconVariant';
export const SnackbarIcon = ({ variant }) => {
    const { iconName, iconColor } = getSnackbarIconVariant(variant);
    return (_jsx(Box, { children: _jsx(Icon, { name: iconName, color: iconColor }) }));
};
